module.exports = __webpack_public_path__ + "static/img/bg_mod_cloud.c7c026c3.jpg";